export default class ModalUploadClassicController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} options
	 */
	constructor($uibModalInstance, options) {
		this.$uibModalInstance = $uibModalInstance;
		this.options = options;
	}

	cancel() {
		this.$uibModalInstance.dismiss();
	}

	finish() {
		this.$uibModalInstance.close({ type: 'success' });
	}

	submit() {
		this.$uibModalInstance.close();
	}
}
